import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import DocketEntriesTableBody from './DocketEntriesTableBody';
import MissingEntry from './MissingEntry';
import DocketEntry from './DocketEntry';
import DocketEntriesTableHeader from './DocketEntriesTableHeader';

class DocketEntries extends Component {
  render() {
    const {
      lastUpdated,
      redact,
      buyMissingDockets,
      showRedactPopup,
      case_uuid,
      court_code,
      case_number,
      sortDockets,
      updateClick,
      pastEntriesClick,
      entries,
      showMissingDockets,
      latest_known_date_filed,
      selectedDocket,
    } = this.props;

    // consider moving the rows prop to instead be react-children
    let itemRows = null;

    if (_.isEmpty(entries.data)) {
      itemRows = (
        <tr key="empty-data">
          <td colSpan="4"> No Dockets Found</td>
        </tr>
      );
    } else {
      itemRows = entries.data.reduce((accum, docket, idx) => {
        const key = `docket-entry-${idx}`;

        if (docket.missing && showMissingDockets) {
          accum.push(
            <MissingEntry id={key} key={key} missing={docket.missing} buyMissingDockets={buyMissingDockets} />
          );
          return accum;
        }

        if (docket.isVisible) {
          accum.push(
            <DocketEntry
              id={key}
              key={key}
              docket={docket}
              redact={redact}
              showRedactPopup={showRedactPopup}
              case_uuid={case_uuid}
              court_code={court_code}
              case_number={case_number}
              onGetDocuments={this.props.onGetDocuments}
              selectedDocket={selectedDocket}
            />
          );
        }

        return accum;
      }, []);
    }

    const lastUpdatedTitle = `Import dockets from ${latest_known_date_filed} to present and update header.\nPACER charges apply per click.`;

    return (
      <div id="ir-search-dockets-results" className={this.props.className}>
        <table className="filter-searchable">
          <DocketEntriesTableHeader
            sortDockets={sortDockets}
            lastUpdated={lastUpdated}
            lastUpdatedTitle={lastUpdatedTitle}
            updateClick={updateClick}
            pastEntriesClick={pastEntriesClick}
          />

          <DocketEntriesTableBody rows={itemRows} keywords={this.props.keyword} />
        </table>
      </div>
    );
  }
}

DocketEntries.defaultProps = {
  redact: null,
  showMissingDockets: false,
  className: '',
  // used to identify this specific component when used as React.Child
  // https://github.com/facebook/react/issues/4915
  displayName: 'DocketEntries',
  keyword: null,
};

DocketEntries.propTypes = {
  entries: PropTypes.object.isRequired,
  lastUpdated: PropTypes.any.isRequired,
  buyMissingDockets: PropTypes.any.isRequired,
  onGetDocuments: PropTypes.any.isRequired,
  showRedactPopup: PropTypes.any.isRequired,
  case_uuid: PropTypes.any.isRequired,
  sortDockets: PropTypes.any.isRequired,
  updateClick: PropTypes.any.isRequired,
  pastEntriesClick: PropTypes.any.isRequired,
  latest_known_date_filed: PropTypes.string.isRequired,
  redact: PropTypes.any,
  showMissingDockets: PropTypes.bool,
  className: PropTypes.string,
  // eslint-disable-next-line
  displayName: PropTypes.string,
  keyword: PropTypes.string,
  court_code: PropTypes.string.isRequired,
  case_number: PropTypes.string.isRequired,
  selectedDocket: PropTypes.object.isRequired,
};

export default DocketEntries;



// WEBPACK FOOTER //
// ./src/components/case/docket/docketEntries/DocketEntries.jsx